import { gql } from 'apollo-boost';

export const COURSES_QUERY = gql`
  query courses($brandId: UUID) {
    courses(useSegmentationFilter: false) {
      edges {
        enrollment {
          id
          userCertificate(brandId: $brandId) {
            id
            userCertificateUrl
          }
        }
        node {
          id
          courseCertificates {
            id
            brand {
              id
              name
            }
          }
          locales {
            locale
            name
            description
          }
          heroImage {
            id
            url
          }
          thumbnailImage {
            id
            url
          }
          tagIds
          learningObjects {
            totalCount
            edges {
              assignment {
                status
                startedAt
                completedAt
                score
              }
              node {
                id
                duration
                content {
                  id
                  mimetype
                  url
                }
              }
            }
          }
          localeIds
          companyRelationshipIds
          productIds
          brandIds
          learningProfileIds
          categoryIds
          metadata
        }
      }
    }
  }
`;
